import { ChatInitiativeOptionsType } from './types';

export const CHAT_INITIATIVE_OPTIONS: ChatInitiativeOptionsType = [
  {
    id: 'yes',
    title: 'Yes',
    description: 'I miss you',
  },
  {
    id: 'i_take_the_lead',
    title: 'I take the lead',
    description: 'Hey babe..',
  },
];
